import { useMutation } from "@apollo/client/react";
import queryString from "query-string";
import { useEffect } from "react";
import { Navigate, useLocation } from "react-router";

import FlashContext from "components/FlashMessages/FlashContext";
import SystemMessage from "components/SystemMessage";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import useTypedContext from "hooks/useTypedContext";

import { CONFIRM_TOKEN } from "./gql";

const CLILogin = () => {
  const { search } = useLocation();
  const { key, port } = queryString.parse(search);
  const { onError } = useTypedContext(FlashContext);

  const [getCLIConfirmationToken, { data, loading }] = useMutation<{
    cliConfirmationToken: string;
  }>(CONFIRM_TOKEN);

  const handleCliLogin = () => {
    if (data?.cliConfirmationToken) {
      window.location.href = `${window.location.origin}/cli_auth?token=${data.cliConfirmationToken}&port=${port}`;
    }
  };

  useEffect(() => {
    const asyncEffect = async () => {
      try {
        if (key && !data) {
          await getCLIConfirmationToken({ variables: { pubKey: key } });
        }
      } catch (error) {
        onError(error);
      }
    };

    void asyncEffect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  if (!key) {
    return <Navigate to="/auth_failure" replace />;
  }

  return (
    <SystemMessage
      title="Log in to the Spacelift CLI"
      message="When you are ready to authenticate press the button below"
    >
      <Box direction="column" gap="x-large" fullWidth>
        <Button
          variant="primary"
          onPress={handleCliLogin}
          loading={loading}
          disabled={!data?.cliConfirmationToken}
        >
          Login
        </Button>
      </Box>
    </SystemMessage>
  );
};

export default CLILogin;
